import React, {useEffect, useRef} from "react";
import LIUtils from "../GUI_COMMON/SUPPORT/LIUtils";
import LIButton from "../GUI_COMMON/COMPONENTS/LIButton";
import ImageGenerator from "./ADMIN/ImageGenerator";
import PropTypes from "prop-types";
import ErrorPopup from "../GUI_COMMON/COMPONENTS/ErrorPopup";
import {ImageInfoStruct} from "./ImageInfoStruct";


const ImageSetterCard = ({imageInfo,disabled,onSaveClicked}) => {

    const MAX_IMAGE_SIZE_BYTES = 65535;
    
    const [dataBytesForSaving, setDataBytesForSaving] = React.useState(null);

    const fileOpenRef = useRef(null);
    
    useEffect( () => {
        // add our change listener for the file uploader here
        const fileRefHolder = fileOpenRef.current;
        fileRefHolder.removeEventListener("change",uploadImageFileSelected);
        fileRefHolder.addEventListener("change", uploadImageFileSelected, false);
        return( () => { // unmount
            if(fileRefHolder) {
                fileRefHolder.removeEventListener("change", uploadImageFileSelected);
            }
        });
    },[fileOpenRef]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if(dataBytesForSaving) {
            onSaveClicked(dataBytesForSaving);
        }
    }, [dataBytesForSaving]); // eslint-disable-line react-hooks/exhaustive-deps
    
    function uploadImageFileSelected(e) {
        const files = e.target.files;
        if(files.length===0) {
            return;
        }
        const firstFile = files[0];

        const reader = new FileReader();
        reader.onload = (e) => {
            const dataBytes = e.target.result;
            const readyState = e.target.readyState;
            console.debug("ready state is '"+readyState+"'");
            const numBytes = e.total;
            console.debug("file size='"+numBytes+"' bytes");
            if(numBytes > MAX_IMAGE_SIZE_BYTES) { // currently the limit of our db images column.
                ErrorPopup.showError("Image Too Large", `Image needs to be < ${MAX_IMAGE_SIZE_BYTES} bytes`)
                return; // bail
            }

            // reset the filename so we can do it again  *** IMPORTANT IF SAME FILE IS SELECTED AGAIN
            fileOpenRef.current.value="";
            //onSaveClicked(dataBytes);
            setDataBytesForSaving(dataBytes);
        }
        reader.readAsArrayBuffer(firstFile);
        console.debug(`image file selected was ${firstFile.name}`);
    }
    
    function showImageChangedIndicator() {
        if(imageInfo.hasUnsavedData) {
            return(
                <div className="ml-0">
                    <span className="fa fa-asterisk fa-1x text-danger position-relative" style={{top:"0px",left:"0px"}} 
                            inert="true"></span>
                </div>
            );
        }

        return null;
    }

    function showImageFilePicker(e) {
        e.preventDefault();
        e.stopPropagation();

        fileOpenRef.current.click(); // open the file picker
    }
    
    return (
        <div className="card">
            <div className="card-body bg-light">
                <div className="row m-0 p-0 ml-5 mt-2">
                    {LIUtils.getImgFromImageData(imageInfo.encodedBytes, null, 150, null, 100)}
                    {showImageChangedIndicator()}
                    <div className="col-10 col-lg-6 mt-4 mt-lg-0">
                        <LIButton bgClass="ml-2" medium secondary label="Upload New File Image"
                                  disabled={disabled} fitHeight
                                  onClick={showImageFilePicker}/>
                    </div>
                    <div className="col-2 col-lg-2 mt-4 mt-lg-0">
                        <ImageGenerator onSaveDataBytes={(dataBytes) => setDataBytesForSaving(dataBytes)} 
                                        fontSizePels={100} text="My Image"
                                        disabled={disabled}/>
                    </div>
                </div>
                <div className="li-font-tiny">* recommended image dimensions: width: 360, height: 240</div>
                <div className="li-font-tiny">* max image bytes: {MAX_IMAGE_SIZE_BYTES} bytes</div>
            </div>
            {/* our file uploader */}
            <input type="file" ref={fileOpenRef} id="uploadFileInput" name="uploadFileInput" className="d-none" accept="image/jpeg,image/png"/>
        </div>
    );
};

ImageSetterCard.propTypes = {
    imageInfo: PropTypes.instanceOf(ImageInfoStruct).isRequired,
    onSaveClicked: PropTypes.func.isRequired,
    disabled: PropTypes.bool.isRequired,
};

export default ImageSetterCard;